import { useEffect, useState, useRef } from "react";
import api from "../../../api/axiosInstance";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Unauthorized from "../../../Components/custom/Unauthrized";
import { OverlayTrigger, Tooltip, Badge } from "react-bootstrap";
import {
  FaUsers,
  FaUserShield,
  FaSchool,
  FaBuilding,
  FaChartLine,
  FaCog,
  FaEye,
  FaPlus,
  FaEdit,
  FaTrash,
  FaGraduationCap,
  FaUserGraduate,
  FaBook,
  FaFileExport,
  FaCheckCircle,
  FaSave,
  FaTimes,
  FaUsersCog,
  FaChalkboardTeacher,
} from "react-icons/fa";
import { BsToggleOn, BsToggleOff } from "react-icons/bs";
const ManageRoles = (props) => {
  const pId = useParams();
  const navigate = useNavigate();
  const [permissions, setPermissions] = useState({
    roleId: 0,
    roleName: "",
  });
  const [hasChanges, setHasChanges] = useState(false);
  const [errors, setErrors] = useState({});

  // Ref for focusing on error field
  const roleNameRef = useRef(null);

  const toggleSection = (sectionPermissions) => {
    setPermissions((prevState) => {
      const newState = { ...prevState };
      // Check if all permissions are currently true
      const allSelected = sectionPermissions.every((perm) => prevState[perm]);
      // Toggle: if all selected, unselect all; otherwise, select all
      const newValue = !allSelected;
      sectionPermissions.forEach((perm) => {
        newState[perm] = newValue;
      });
      return newState;
    });
    setHasChanges(true);
  };

  const handlePermissionChange = (permission, value) => {
    setPermissions((prevState) => ({
      ...prevState,
      [permission]: value,
    }));
    setHasChanges(true);
  };
  const saveRole = () => {
    // Validate required fields before submission
    const validationErrors = {};
    let hasErrors = false;

    if (!permissions.roleName || permissions.roleName.trim() === "") {
      validationErrors.RoleName = ["The RoleName field is required."];
      hasErrors = true;
    }

    if (hasErrors) {
      setErrors(validationErrors);
      // Focus on the role name field
      setTimeout(() => {
        if (roleNameRef.current) {
          roleNameRef.current.focus();
        }
      }, 100);
      toast.warning("Please review and correct the required fields");
      return;
    }

    // Clear errors if validation passes
    setErrors({});

    var config = {};
    if (pId.RoleId == 0) {
      config = {
        method: "post",
        url: process.env.REACT_APP_API_URL + "Roles/AddRoles/",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
        data: permissions,
      };
    } else {
      config = {
        method: "post",
        url: process.env.REACT_APP_API_URL + "Roles/UpdateRole",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
        data: permissions,
      };
    }

    api(config)
      .then(function (response) {
        if (response.data.statusCode === 200) {
          if (pId.RoleId == 0) {
            toast.success("Role Added Successfully");
            navigate("/Settings/Roles");
          } else {
            getRole();
            toast.success("Role Updated Successfully");
            setErrors({});
          }
        }
      })
      .catch(function (error) {
        if (error?.response?.data?.errors) {
          const validationErrors = error.response.data.errors;
          setErrors(validationErrors);
          setTimeout(() => {
            if (roleNameRef.current) {
              roleNameRef.current.focus();
            }
          }, 100);
          toast.warning("Please review and correct the required fields");
        } else {
          toast.error(
            error?.response?.data?.message ||
              (pId.RoleId == 0
                ? "Failed to add role"
                : "Failed to update role"),
          );
        }
      });
  };

  const getRole = () => {
    var config = {
      method: "get",
      url: process.env.REACT_APP_API_URL + "Roles/GetRole/" + pId.RoleId,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    };

    api(config).then(function (response) {
      if (response.data.statusCode === 200) {
        setPermissions(response.data.content);
        setErrors({});
      }
    });
  };
  useEffect(() => {
    getRole();
  }, []);
  return (
    <>
      {props.userPermissions.addRoles || props.userPermissions.editRoles ? (
        <>
          <div className="container-fluid mt-30">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title d-flex align-items-center gap-2">
                      <FaUserShield
                        size={24}
                        style={{ color: "var(--cts-primary)" }}
                      />
                      {pId.RoleId == 0 ? "Create New Role" : "Edit Role"}
                      {hasChanges && (
                        <Badge
                          bg="warning"
                          className="ms-2"
                          style={{ fontSize: "0.7rem" }}
                        >
                          Unsaved Changes
                        </Badge>
                      )}
                    </h3>
                    <div className="self-content-center d-flex gap-2">
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Cancel and go back</Tooltip>}
                      >
                        <Link
                          to="/Settings/Roles"
                          className="btn btn-sm btn-secondary cts-btn-secondary d-flex align-items-center gap-2"
                        >
                          <FaTimes size={14} />
                          Cancel
                        </Link>
                      </OverlayTrigger>
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Save role permissions</Tooltip>}
                      >
                        <button
                          className="btn btn-sm btn-primary cts-btn-primary d-flex align-items-center gap-2"
                          onClick={() => saveRole()}
                        >
                          <FaSave size={14} />
                          Save Changes
                        </button>
                      </OverlayTrigger>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row mb-5">
                      <div className="col-12 col-md-6">
                        <label className="form-label fw-bold">
                          <FaUserShield className="me-2" />
                          Role Name <span className="text-danger">*</span>
                        </label>
                        <input
                          ref={roleNameRef}
                          className={`form-control form-control-sm ${errors.RoleName ? "is-invalid" : ""}`}
                          placeholder="Enter role name (e.g., Admin, Manager)"
                          value={permissions.roleName || ""}
                          onChange={(e) => {
                            setPermissions((prevState) => ({
                              ...prevState,
                              roleName: e.target.value,
                            }));
                            setHasChanges(true);
                            // Clear error when user starts typing
                            if (errors.RoleName) {
                              setErrors((prevErrors) => {
                                const newErrors = { ...prevErrors };
                                delete newErrors.RoleName;
                                return newErrors;
                              });
                            }
                          }}
                        />
                        {errors.RoleName && (
                          <div
                            className="text-warning"
                            style={{
                              fontSize: "0.875rem",
                              marginTop: "0.25rem",
                            }}
                          >
                            {errors.RoleName[0]}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Dashboard Section */}
                    <div
                      className="card mb-4"
                      style={{ border: "1px solid #e0e0e0" }}
                    >
                      <div
                        className="card-header"
                        style={{
                          backgroundColor: "#fff",
                          borderBottom: "2px solid #e0e0e0",
                        }}
                      >
                        <div className="d-flex align-items-center justify-content-between">
                          <h5
                            className="mb-0 d-flex align-items-center gap-2"
                            style={{ color: "#fdf9f9ff" }}
                          >
                            <FaChartLine
                              size={20}
                              style={{ color: "#fdf9f9ff" }}
                            />
                            Dashboard & Analytics
                          </h5>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-12">
                            <OverlayTrigger
                              placement="left"
                              overlay={
                                <Tooltip>
                                  Allow access to the main dashboard with KPIs
                                  and analytics
                                </Tooltip>
                              }
                            >
                              <div className="form-check form-switch form-check-custom form-check-solid mb-3">
                                <input
                                  className="form-check-input h-20px w-30px"
                                  type="checkbox"
                                  id="viewDashboard"
                                  checked={permissions.viewDashboard}
                                  onChange={(e) =>
                                    handlePermissionChange(
                                      "viewDashboard",
                                      e.target.checked,
                                    )
                                  }
                                />
                                <label
                                  className="form-check-label d-flex align-items-center gap-2"
                                  htmlFor="viewDashboard"
                                >
                                  {/* <FaEye size={14} /> */}
                                  View Dashboard
                                </label>
                              </div>
                            </OverlayTrigger>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-2">
                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                          <input
                            className="form-check-input h-20px w-30px"
                            type="checkbox"
                            id="usersView"
                            checked={permissions.kpi22}
                            onChange={(e) =>
                              setPermissions((prevState) => ({
                                ...prevState,
                                kpi22: e.target.checked,
                              }))
                            }
                          />
                          <label className="form-check-label" for="usersView">
                            KPI 2.2 : Graded assignments vs Completed
                            Assignments
                          </label>
                        </div>
                      </div>
                      <div className="col-2">
                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                          <input
                            className="form-check-input h-20px w-30px"
                            type="checkbox"
                            id="editRole"
                            checked={permissions.kpi6}
                            onChange={(e) =>
                              setPermissions((prevState) => ({
                                ...prevState,
                                kpi6: e.target.checked,
                              }))
                            }
                          />
                          <label className="form-check-label" for="editRole">
                            KPI 6 : Never Logged Students
                          </label>
                        </div>
                      </div>
                      <div className="col-2">
                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                          <input
                            className="form-check-input h-20px w-30px"
                            type="checkbox"
                            id="editRole"
                            checked={permissions.kpi7}
                            onChange={(e) =>
                              setPermissions((prevState) => ({
                                ...prevState,
                                kpi7: e.target.checked,
                              }))
                            }
                          />
                          <label className="form-check-label" for="editRole">
                            KPI 7: Logged Students vs Total Number
                          </label>
                        </div>
                      </div>
                      <div className="col-2">
                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                          <input
                            className="form-check-input h-20px w-30px"
                            type="checkbox"
                            id="editRole"
                            checked={permissions.kpi8}
                            onChange={(e) =>
                              setPermissions((prevState) => ({
                                ...prevState,
                                kpi8: e.target.checked,
                              }))
                            }
                          />
                          <label className="form-check-label" for="editRole">
                            KPI 8: Student's Viewing Unique Grades
                          </label>
                        </div>
                      </div> */}
                    {/* <div className="col-2">
                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                      <input
                        className="form-check-input h-20px w-30px"
                        type="checkbox"
                        id="editRole"
                        checked={permissions.kpi22}
                        onChange={(e) =>
                          setPermissions((prevState) => ({
                            ...prevState,
                            kpi10: e.target.checked,
                          }))
                        }
                      />
                      <label className="form-check-label" for="editRole">
                        KPI 10
                      </label>
                    </div>
                  </div> */}
                    {/* <div className="col-2">
                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                          <input
                            className="form-check-input h-20px w-30px"
                            type="checkbox"
                            id="editRole"
                            checked={permissions.kpi14}
                            onChange={(e) =>
                              setPermissions((prevState) => ({
                                ...prevState,
                                kpi14: e.target.checked,
                              }))
                            }
                          />
                          <label className="form-check-label" for="editRole">
                            KPI 14: Never Logged Teachers
                          </label>
                        </div>
                      </div>
                      <div className="col-2">
                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                          <input
                            className="form-check-input h-20px w-30px"
                            type="checkbox"
                            id="editRole"
                            checked={permissions.kpi15}
                            onChange={(e) =>
                              setPermissions((prevState) => ({
                                ...prevState,
                                kpi15: e.target.checked,
                              }))
                            }
                          />
                          <label className="form-check-label" for="editRole">
                            KPI 15: Logged Teachers vs Total Number
                          </label>
                        </div>
                      </div>
                      <div className="col-2">
                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                          <input
                            className="form-check-input h-20px w-30px"
                            type="checkbox"
                            id="editRole"
                            checked={permissions.kpi16}
                            onChange={(e) =>
                              setPermissions((prevState) => ({
                                ...prevState,
                                kpi16: e.target.checked,
                              }))
                            }
                          />
                          <label className="form-check-label" for="editRole">
                            KPI 16: Total Published vs Total Unpublished Courses
                          </label>
                        </div>
                      </div>
                      <div className="col-2">
                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                          <input
                            className="form-check-input h-20px w-30px"
                            type="checkbox"
                            id="editRole"
                            checked={permissions.kpi18}
                            onChange={(e) =>
                              setPermissions((prevState) => ({
                                ...prevState,
                                kpi18: e.target.checked,
                              }))
                            }
                          />
                          <label className="form-check-label" for="editRole">
                            KPI 18: Total Learning Outcomes Linked to
                            Assignments
                          </label>
                        </div>
                      </div>
                      <div className="col-2">
                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                          <input
                            className="form-check-input h-20px w-30px"
                            type="checkbox"
                            id="editRole"
                            checked={permissions.kpi19}
                            onChange={(e) =>
                              setPermissions((prevState) => ({
                                ...prevState,
                                kpi19: e.target.checked,
                              }))
                            }
                          />
                          <label className="form-check-label" for="editRole">
                            KPI 19: Assignments with Learning Outcomes
                          </label>
                        </div>
                      </div> */}

                    {/* Settings Section */}
                    <div
                      className="card mb-4"
                      style={{ border: "1px solid #e0e0e0" }}
                    >
                      <div
                        className="card-header"
                        style={{
                          backgroundColor: "#fff",
                          borderBottom: "2px solid #e0e0e0",
                        }}
                      >
                        <div className="d-flex align-items-center justify-content-between">
                          <h5
                            className="mb-0 d-flex align-items-center gap-2"
                            style={{ color: "#fdf9f9ff" }}
                          >
                            <FaCog size={20} style={{ color: "#fdf9f9ff" }} />
                            Settings & Configuration
                          </h5>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="row mb-3">
                          <div className="col-12">
                            <OverlayTrigger
                              placement="left"
                              overlay={
                                <Tooltip>
                                  Allow access to settings and configuration
                                  pages
                                </Tooltip>
                              }
                            >
                              <div className="form-check form-switch form-check-custom form-check-solid mb-3">
                                <input
                                  className="form-check-input h-20px w-30px"
                                  type="checkbox"
                                  id="viewSettings"
                                  checked={permissions.viewSettings}
                                  onChange={(e) =>
                                    handlePermissionChange(
                                      "viewSettings",
                                      e.target.checked,
                                    )
                                  }
                                />
                                <label
                                  className="form-check-label d-flex align-items-center gap-2"
                                  htmlFor="viewSettings"
                                >
                                  View Settings
                                </label>
                              </div>
                            </OverlayTrigger>
                          </div>
                        </div>
                        <div className="row">
                          {/* Users Permissions */}
                          <div className="col-6 col-md-4 col-lg-3 col-xl-3 mb-4">
                            <div
                              className="card h-100"
                              style={{
                                border: "1px solid #dee2e6",
                                borderRadius: "8px",
                              }}
                            >
                              <div className="card-body p-3">
                                <div className="d-flex align-items-center justify-content-between mb-3">
                                  <h6 className="mb-0 d-flex align-items-center gap-2">
                                    <FaUsers
                                      size={16}
                                      style={{ color: "var(--cts-primary)" }}
                                    />
                                    Users
                                  </h6>

                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Toggle all</Tooltip>}
                                  >
                                    <button
                                      className="btn btn-sm btn-link p-0"
                                      onClick={() =>
                                        toggleSection([
                                          "viewUsers",
                                          "addUser",
                                          "editUser",
                                          "deleteUser",
                                        ])
                                      }
                                      style={{
                                        fontSize: "0.75rem",
                                        textDecoration: "none",
                                      }}
                                    >
                                      {permissions.viewUsers &&
                                      permissions.addUser &&
                                      permissions.editUser &&
                                      permissions.deleteUser ? (
                                        <BsToggleOn
                                          size={25}
                                          style={{
                                            color: "var(--cts-primary)",
                                          }}
                                        />
                                      ) : (
                                        <BsToggleOff
                                          size={25}
                                          style={{ color: "#6c757d" }}
                                        />
                                      )}
                                    </button>
                                  </OverlayTrigger>
                                </div>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip>View users list</Tooltip>}
                                >
                                  <div
                                    className="form-check form-switch mb-2"
                                    style={{ width: "fit-content" }}
                                  >
                                    <input
                                      className="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      id="viewUsers"
                                      checked={permissions.viewUsers}
                                      onChange={(e) =>
                                        handlePermissionChange(
                                          "viewUsers",
                                          e.target.checked,
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="viewUsers"
                                    >
                                      View
                                    </label>
                                  </div>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip>Create new users</Tooltip>}
                                >
                                  <div
                                    className="form-check form-switch mb-2"
                                    style={{ width: "fit-content" }}
                                  >
                                    <input
                                      className="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      id="addUser"
                                      checked={permissions.addUser}
                                      onChange={(e) =>
                                        handlePermissionChange(
                                          "addUser",
                                          e.target.checked,
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="addUser"
                                    >
                                      Add
                                    </label>
                                  </div>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip>Edit user information</Tooltip>
                                  }
                                >
                                  <div
                                    className="form-check form-switch mb-2"
                                    style={{ width: "fit-content" }}
                                  >
                                    <input
                                      className="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      id="editUser"
                                      checked={permissions.editUser}
                                      onChange={(e) =>
                                        handlePermissionChange(
                                          "editUser",
                                          e.target.checked,
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="editUser"
                                    >
                                      Edit
                                    </label>
                                  </div>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip>Delete users</Tooltip>}
                                >
                                  <div
                                    className="form-check form-switch"
                                    style={{ width: "fit-content" }}
                                  >
                                    <input
                                      className="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      id="deleteUser"
                                      checked={permissions.deleteUser}
                                      onChange={(e) =>
                                        handlePermissionChange(
                                          "deleteUser",
                                          e.target.checked,
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="deleteUser"
                                    >
                                      Delete
                                    </label>
                                  </div>
                                </OverlayTrigger>
                              </div>
                            </div>
                          </div>

                          {/* Roles Permissions */}
                          <div className="col-6 col-md-4 col-lg-3 col-xl-3 mb-4">
                            <div
                              className="card h-100"
                              style={{
                                border: "1px solid #dee2e6",
                                borderRadius: "8px",
                              }}
                            >
                              <div className="card-body p-3">
                                <div className="d-flex align-items-center justify-content-between mb-3">
                                  <h6 className="mb-0 d-flex align-items-center gap-2">
                                    <FaUserShield
                                      size={16}
                                      style={{ color: "var(--cts-primary)" }}
                                    />
                                    Roles
                                  </h6>
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Toggle all</Tooltip>}
                                  >
                                    <button
                                      className="btn btn-sm btn-link p-0"
                                      onClick={() =>
                                        toggleSection([
                                          "viewRoles",
                                          "addRole",
                                          "editRole",
                                          "deleteRole",
                                        ])
                                      }
                                      style={{
                                        fontSize: "0.75rem",
                                        textDecoration: "none",
                                      }}
                                    >
                                      {permissions.viewRoles &&
                                      permissions.addRole &&
                                      permissions.editRole &&
                                      permissions.deleteRole ? (
                                        <BsToggleOn
                                          size={22}
                                          style={{
                                            color: "var(--cts-primary)",
                                          }}
                                        />
                                      ) : (
                                        <BsToggleOff
                                          size={22}
                                          style={{ color: "#6c757d" }}
                                        />
                                      )}
                                    </button>
                                  </OverlayTrigger>
                                </div>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip>View roles list</Tooltip>}
                                >
                                  <div
                                    className="form-check form-switch mb-2"
                                    style={{ width: "fit-content" }}
                                  >
                                    <input
                                      className="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      id="viewRoles"
                                      checked={permissions.viewRoles}
                                      onChange={(e) =>
                                        handlePermissionChange(
                                          "viewRoles",
                                          e.target.checked,
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="viewRoles"
                                    >
                                      View
                                    </label>
                                  </div>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip>Create new roles</Tooltip>}
                                >
                                  <div
                                    className="form-check form-switch mb-2"
                                    style={{ width: "fit-content" }}
                                  >
                                    <input
                                      className="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      id="addRole"
                                      checked={permissions.addRole}
                                      onChange={(e) =>
                                        handlePermissionChange(
                                          "addRole",
                                          e.target.checked,
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="addRole"
                                    >
                                      Add
                                    </label>
                                  </div>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip>Edit role permissions</Tooltip>
                                  }
                                >
                                  <div
                                    className="form-check form-switch mb-2"
                                    style={{ width: "fit-content" }}
                                  >
                                    <input
                                      className="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      id="editRole"
                                      checked={permissions.editRole}
                                      onChange={(e) =>
                                        handlePermissionChange(
                                          "editRole",
                                          e.target.checked,
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="editRole"
                                    >
                                      Edit
                                    </label>
                                  </div>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip>Delete roles</Tooltip>}
                                >
                                  <div
                                    className="form-check form-switch"
                                    style={{ width: "fit-content" }}
                                  >
                                    <input
                                      className="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      id="deleteRole"
                                      checked={permissions.deleteRole}
                                      onChange={(e) =>
                                        handlePermissionChange(
                                          "deleteRole",
                                          e.target.checked,
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="deleteRole"
                                    >
                                      Delete
                                    </label>
                                  </div>
                                </OverlayTrigger>
                              </div>
                            </div>
                          </div>

                          {/* Schools Permissions */}
                          <div className="col-6 col-md-4 col-lg-3 col-xl-3 mb-4">
                            <div
                              className="card h-100"
                              style={{
                                border: "1px solid #dee2e6",
                                borderRadius: "8px",
                              }}
                            >
                              <div className="card-body p-3">
                                <div className="d-flex align-items-center justify-content-between mb-3">
                                  <h6 className="mb-0 d-flex align-items-center gap-2">
                                    <FaSchool
                                      size={16}
                                      style={{ color: "var(--cts-primary)" }}
                                    />
                                    Schools
                                  </h6>
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Toggle all</Tooltip>}
                                  >
                                    <button
                                      className="btn btn-sm btn-link p-0"
                                      onClick={() =>
                                        toggleSection([
                                          "viewSchools",
                                          "addSchool",
                                          "editSchool",
                                          "deleteSchool",
                                        ])
                                      }
                                      style={{
                                        fontSize: "0.75rem",
                                        textDecoration: "none",
                                      }}
                                    >
                                      {permissions.viewSchools &&
                                      permissions.addSchool &&
                                      permissions.editSchool &&
                                      permissions.deleteSchool ? (
                                        <BsToggleOn
                                          size={22}
                                          style={{
                                            color: "var(--cts-primary)",
                                          }}
                                        />
                                      ) : (
                                        <BsToggleOff
                                          size={22}
                                          style={{ color: "#6c757d" }}
                                        />
                                      )}
                                    </button>
                                  </OverlayTrigger>
                                </div>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip>View schools list</Tooltip>}
                                >
                                  <div
                                    className="form-check form-switch mb-2"
                                    style={{ width: "fit-content" }}
                                  >
                                    <input
                                      className="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      id="viewSchools"
                                      checked={permissions.viewSchools}
                                      onChange={(e) =>
                                        handlePermissionChange(
                                          "viewSchools",
                                          e.target.checked,
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="viewSchools"
                                    >
                                      View
                                    </label>
                                  </div>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip>Add new schools</Tooltip>}
                                >
                                  <div
                                    className="form-check form-switch mb-2"
                                    style={{ width: "fit-content" }}
                                  >
                                    <input
                                      className="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      id="addSchool"
                                      checked={permissions.addSchool}
                                      onChange={(e) =>
                                        handlePermissionChange(
                                          "addSchool",
                                          e.target.checked,
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="addSchool"
                                    >
                                      Add
                                    </label>
                                  </div>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip>Edit school information</Tooltip>
                                  }
                                >
                                  <div
                                    className="form-check form-switch mb-2"
                                    style={{ width: "fit-content" }}
                                  >
                                    <input
                                      className="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      id="editSchool"
                                      checked={permissions.editSchool}
                                      onChange={(e) =>
                                        handlePermissionChange(
                                          "editSchool",
                                          e.target.checked,
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="editSchool"
                                    >
                                      Edit
                                    </label>
                                  </div>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip>Delete schools</Tooltip>}
                                >
                                  <div
                                    className="form-check form-switch"
                                    style={{ width: "fit-content" }}
                                  >
                                    <input
                                      className="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      id="deleteSchool"
                                      checked={permissions.deleteSchool}
                                      onChange={(e) =>
                                        handlePermissionChange(
                                          "deleteSchool",
                                          e.target.checked,
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="deleteSchool"
                                    >
                                      Delete
                                    </label>
                                  </div>
                                </OverlayTrigger>
                              </div>
                            </div>
                          </div>

                          {/* Operators Permissions */}
                          <div className="col-6 col-md-4 col-lg-3 col-xl-3 mb-4">
                            <div
                              className="card h-100"
                              style={{
                                border: "1px solid #dee2e6",
                                borderRadius: "8px",
                              }}
                            >
                              <div className="card-body p-3">
                                <div className="d-flex align-items-center justify-content-between mb-3">
                                  <h6 className="mb-0 d-flex align-items-center gap-2">
                                    <FaBuilding
                                      size={16}
                                      style={{ color: "var(--cts-primary)" }}
                                    />
                                    Operators
                                  </h6>
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Toggle all</Tooltip>}
                                  >
                                    <button
                                      className="btn btn-sm btn-link p-0"
                                      onClick={() =>
                                        toggleSection([
                                          "viewOperators",
                                          "addOperator",
                                          "editOperator",
                                          "deleteOperator",
                                        ])
                                      }
                                      style={{
                                        fontSize: "0.75rem",
                                        textDecoration: "none",
                                      }}
                                    >
                                      {permissions.viewOperators &&
                                      permissions.addOperator &&
                                      permissions.editOperator &&
                                      permissions.deleteOperator ? (
                                        <BsToggleOn
                                          size={22}
                                          style={{
                                            color: "var(--cts-primary)",
                                          }}
                                        />
                                      ) : (
                                        <BsToggleOff
                                          size={22}
                                          style={{ color: "#6c757d" }}
                                        />
                                      )}
                                    </button>
                                  </OverlayTrigger>
                                </div>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip>View operators list</Tooltip>
                                  }
                                >
                                  <div
                                    className="form-check form-switch mb-2"
                                    style={{ width: "fit-content" }}
                                  >
                                    <input
                                      className="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      id="viewOperators"
                                      checked={permissions.viewOperators}
                                      onChange={(e) =>
                                        handlePermissionChange(
                                          "viewOperators",
                                          e.target.checked,
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="viewOperators"
                                    >
                                      View
                                    </label>
                                  </div>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip>Create new operators</Tooltip>
                                  }
                                >
                                  <div
                                    className="form-check form-switch mb-2"
                                    style={{ width: "fit-content" }}
                                  >
                                    <input
                                      className="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      id="addOperator"
                                      checked={permissions.addOperator}
                                      onChange={(e) =>
                                        handlePermissionChange(
                                          "addOperator",
                                          e.target.checked,
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="addOperator"
                                    >
                                      Add
                                    </label>
                                  </div>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip>Edit operator information</Tooltip>
                                  }
                                >
                                  <div
                                    className="form-check form-switch mb-2"
                                    style={{ width: "fit-content" }}
                                  >
                                    <input
                                      className="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      id="editOperator"
                                      checked={permissions.editOperator}
                                      onChange={(e) =>
                                        handlePermissionChange(
                                          "editOperator",
                                          e.target.checked,
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="editOperator"
                                    >
                                      Edit
                                    </label>
                                  </div>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip>Delete operators</Tooltip>}
                                >
                                  <div
                                    className="form-check form-switch"
                                    style={{ width: "fit-content" }}
                                  >
                                    <input
                                      className="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      id="deleteOperator"
                                      checked={permissions.deleteOperator}
                                      onChange={(e) =>
                                        handlePermissionChange(
                                          "deleteOperator",
                                          e.target.checked,
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="deleteOperator"
                                    >
                                      Delete
                                    </label>
                                  </div>
                                </OverlayTrigger>
                              </div>
                            </div>
                          </div>
                          {/* <div className='col-6 col-md-2 mb-3'>
                        <h6>Variables</h6>
                        <div className='col-12'>
                          <div className='form-check form-switch form-check-custom form-check-solid me-10'>
                            <input
                              className='form-check-input h-20px w-30px'
                              type='checkbox'
                              id='usersView'
                              checked={permissions.viewSchools}
                              onChange={(e) =>
                                setPermissions((prevState) => ({
                                  ...prevState,
                                  viewSchools: e.target.checked,
                                }))
                              }
                            />
                            <label className='form-check-label' for='usersView'>
                              View
                            </label>
                          </div>
                        </div>
                        <div className='col-12'>
                          <div className='form-check form-switch form-check-custom form-check-solid me-10'>
                            <input
                              className='form-check-input h-20px w-30px'
                              type='checkbox'
                              id='editRole'
                              checked={permissions.editSchool}
                              onChange={(e) =>
                                setPermissions((prevState) => ({
                                  ...prevState,
                                  editSchool: e.target.checked,
                                }))
                              }
                            />
                            <label className='form-check-label' for='editRole'>
                              Edit
                            </label>
                          </div>
                        </div>
                      </div> */}
                          {/* <div className="col-12 col-md-2 mb-3">
                            <hr></hr>
                          </div> */}
                          {/* <div className="col-12 col-md-2">
                        <h6>Canvas Configurations</h6>
                        <div className="col-12">
                          <div className="form-check form-switch form-check-custom form-check-solid me-10">
                            <input
                              className="form-check-input h-20px w-30px"
                              type="checkbox"
                              id="usersView"
                              checked={permissions.viewUsers}
                              onChange={(e) =>
                                setPermissions((prevState) => ({
                                  ...prevState,
                                  viewUsers: e.target.checked,
                                }))
                              }
                            />
                            <label className="form-check-label" for="usersView">
                              User Provisioning
                            </label>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-check form-switch form-check-custom form-check-solid me-10">
                            <input
                              className="form-check-input h-20px w-30px"
                              type="checkbox"
                              id="usersView"
                              checked={permissions.viewUsers}
                              onChange={(e) =>
                                setPermissions((prevState) => ({
                                  ...prevState,
                                  addUser: e.target.checked,
                                }))
                              }
                            />
                            <label className="form-check-label" for="usersView">
                              Courses Provisioning
                            </label>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-check form-switch form-check-custom form-check-solid me-10">
                            <input
                              className="form-check-input h-20px w-30px"
                              type="checkbox"
                              id="usersView"
                              checked={permissions.viewUsers}
                              onChange={(e) =>
                                setPermissions((prevState) => ({
                                  ...prevState,
                                  editUser: e.target.checked,
                                }))
                              }
                            />
                            <label className="form-check-label" for="usersView">
                              CSLP Students
                            </label>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-check form-switch form-check-custom form-check-solid me-10">
                            <input
                              className="form-check-input h-20px w-30px"
                              type="checkbox"
                              id="usersView"
                              checked={permissions.viewUsers}
                              onChange={(e) =>
                                setPermissions((prevState) => ({
                                  ...prevState,
                                  deleteUser: e.target.checked,
                                }))
                              }
                            />
                            <label className="form-check-label" for="usersView">
                              CSLP Teachers
                            </label>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-check form-switch form-check-custom form-check-solid me-10">
                            <input
                              className="form-check-input h-20px w-30px"
                              type="checkbox"
                              id="usersView"
                              checked={permissions.viewUsers}
                              onChange={(e) =>
                                setPermissions((prevState) => ({
                                  ...prevState,
                                  deleteUser: e.target.checked,
                                }))
                              }
                            />
                            <label className="form-check-label" for="usersView">
                              Students Competency
                            </label>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-check form-switch form-check-custom form-check-solid me-10">
                            <input
                              className="form-check-input h-20px w-30px"
                              type="checkbox"
                              id="usersView"
                              checked={permissions.viewUsers}
                              onChange={(e) =>
                                setPermissions((prevState) => ({
                                  ...prevState,
                                  deleteUser: e.target.checked,
                                }))
                              }
                            />
                            <label className="form-check-label" for="usersView">
                              User Course Access Log
                            </label>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-check form-switch form-check-custom form-check-solid me-10">
                            <input
                              className="form-check-input h-20px w-30px"
                              type="checkbox"
                              id="usersView"
                              checked={permissions.viewUsers}
                              onChange={(e) =>
                                setPermissions((prevState) => ({
                                  ...prevState,
                                  deleteUser: e.target.checked,
                                }))
                              }
                            />
                            <label className="form-check-label" for="usersView">
                              User Login Log
                            </label>
                          </div>
                        </div>
                      </div> */}
                        </div>
                      </div>
                    </div>

                    {/* Data Access Section */}
                    <div
                      className="card mb-4"
                      style={{ border: "1px solid #e0e0e0" }}
                    >
                      <div
                        className="card-header"
                        style={{
                          backgroundColor: "#fff",
                          borderBottom: "2px solid #e0e0e0",
                        }}
                      >
                        <div className="d-flex align-items-center justify-content-between">
                          <h5
                            className="mb-0 d-flex align-items-center gap-2"
                            style={{ color: "#fdf9f9ff" }}
                          >
                            <FaGraduationCap
                              size={20}
                              style={{ color: "#fdf9f9ff" }}
                            />
                            Data Access & Reports
                          </h5>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          {/* View Access Group */}
                          <div className="col-12 mb-4">
                            <h6 className="text-muted mb-3 d-flex align-items-center gap-2">
                              View Access
                            </h6>
                            <div className="row">
                              <div className="col-6 col-md-4 col-lg-3 col-xl-2 mb-3">
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip>
                                      Access to view student data
                                    </Tooltip>
                                  }
                                >
                                  <div
                                    className="form-check form-switch form-check-custom form-check-solid"
                                    style={{ width: "fit-content" }}
                                  >
                                    <input
                                      className="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      id="viewStudents"
                                      checked={permissions.viewStudents}
                                      onChange={(e) =>
                                        handlePermissionChange(
                                          "viewStudents",
                                          e.target.checked,
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="viewStudents"
                                    >
                                      Students
                                    </label>
                                  </div>
                                </OverlayTrigger>
                              </div>

                              <div className="col-6 col-md-4 col-lg-3 col-xl-2 mb-3">
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip>
                                      Access to view teacher data
                                    </Tooltip>
                                  }
                                >
                                  <div
                                    className="form-check form-switch form-check-custom form-check-solid"
                                    style={{ width: "fit-content" }}
                                  >
                                    <input
                                      className="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      id="viewTeachers"
                                      checked={permissions.viewTeachers}
                                      onChange={(e) =>
                                        handlePermissionChange(
                                          "viewTeachers",
                                          e.target.checked,
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="viewTeachers"
                                    >
                                      Teachers
                                    </label>
                                  </div>
                                </OverlayTrigger>
                              </div>

                              <div className="col-6 col-md-4 col-lg-3 col-xl-2 mb-3">
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip>
                                      Access to view course information
                                    </Tooltip>
                                  }
                                >
                                  <div
                                    className="form-check form-switch form-check-custom form-check-solid"
                                    style={{ width: "fit-content" }}
                                  >
                                    <input
                                      className="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      id="viewCourses"
                                      checked={permissions.viewCourses}
                                      onChange={(e) =>
                                        handlePermissionChange(
                                          "viewCourses",
                                          e.target.checked,
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="viewCourses"
                                    >
                                      Courses
                                    </label>
                                  </div>
                                </OverlayTrigger>
                              </div>
                            </div>
                          </div>

                          {/* School Level Access Group */}
                          <div className="col-12 mb-4">
                            <h6 className="text-muted mb-3 d-flex align-items-center gap-2">
                              <FaSchool size={14} />
                              School Level Access
                            </h6>
                            <div className="row">
                              <div className="col-6 col-md-4 col-lg-3 col-xl-2 mb-3">
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip>
                                      Filter data by Middle School
                                    </Tooltip>
                                  }
                                >
                                  <div
                                    className="form-check form-switch form-check-custom form-check-solid"
                                    style={{ width: "fit-content" }}
                                  >
                                    <input
                                      className="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      id="viewMiddleSchool"
                                      checked={permissions.viewMiddleSchool}
                                      onChange={(e) =>
                                        handlePermissionChange(
                                          "viewMiddleSchool",
                                          e.target.checked,
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="viewMiddleSchool"
                                    >
                                      View Middle School
                                    </label>
                                  </div>
                                </OverlayTrigger>
                              </div>

                              <div className="col-6 col-md-4 col-lg-3 col-xl-2 mb-3">
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip>
                                      Filter data by High School
                                    </Tooltip>
                                  }
                                >
                                  <div
                                    className="form-check form-switch form-check-custom form-check-solid"
                                    style={{ width: "fit-content" }}
                                  >
                                    <input
                                      className="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      id="viewHighSchool"
                                      checked={permissions.viewHighSchool}
                                      onChange={(e) =>
                                        handlePermissionChange(
                                          "viewHighSchool",
                                          e.target.checked,
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="viewHighSchool"
                                    >
                                      View High School
                                    </label>
                                  </div>
                                </OverlayTrigger>
                              </div>
                            </div>
                          </div>

                          {/* Export Permissions Group */}
                          <div className="col-12">
                            <h6 className="text-muted mb-3 d-flex align-items-center gap-2">
                              <FaFileExport size={14} />
                              View & Export Gradebook Permissions
                            </h6>
                            <div className="row">
                              <div className="col-6 col-md-4 col-lg-3 col-xl-2 mb-3">
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip>
                                      Access to view grades and assessments
                                    </Tooltip>
                                  }
                                >
                                  <div
                                    className="form-check form-switch form-check-custom form-check-solid"
                                    style={{ width: "fit-content" }}
                                  >
                                    <input
                                      className="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      id="viewGradeBook"
                                      checked={permissions.viewGradeBook}
                                      onChange={(e) =>
                                        handlePermissionChange(
                                          "viewGradeBook",
                                          e.target.checked,
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="viewGradeBook"
                                    >
                                      Gradebook
                                    </label>
                                  </div>
                                </OverlayTrigger>
                              </div>

                              <div className="col-6 col-md-4 col-lg-3 col-xl-3 mb-3">
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip>Export Middle School data</Tooltip>
                                  }
                                >
                                  <div
                                    className="form-check form-switch form-check-custom form-check-solid"
                                    style={{ width: "fit-content" }}
                                  >
                                    <input
                                      className="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      id="exportMiddleSchool"
                                      checked={permissions.exportMiddleSchool}
                                      onChange={(e) =>
                                        handlePermissionChange(
                                          "exportMiddleSchool",
                                          e.target.checked,
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="exportMiddleSchool"
                                    >
                                      Export Middle School
                                    </label>
                                  </div>
                                </OverlayTrigger>
                              </div>

                              <div className="col-6 col-md-4 col-lg-3 col-xl-3 mb-3">
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip>Export High School data</Tooltip>
                                  }
                                >
                                  <div
                                    className="form-check form-switch form-check-custom form-check-solid"
                                    style={{ width: "fit-content" }}
                                  >
                                    <input
                                      className="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      id="exportHighSchool"
                                      checked={permissions.exportHighSchool}
                                      onChange={(e) =>
                                        handlePermissionChange(
                                          "exportHighSchool",
                                          e.target.checked,
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="exportHighSchool"
                                    >
                                      Export High School
                                    </label>
                                  </div>
                                </OverlayTrigger>
                              </div>
                            </div>
                          </div>

                          {/* Export Permissions Group */}
                          <div className="col-12">
                            <h6 className="text-muted mb-3 d-flex align-items-center gap-2">
                              <FaFileExport size={14} />
                              Reports
                            </h6>
                            <div className="row">
                              <div className="col-6 col-md-4 col-lg-3 col-xl-2 mb-3">
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip>Teacher Compliance</Tooltip>
                                  }
                                >
                                  <div
                                    className="form-check form-switch form-check-custom form-check-solid"
                                    style={{ width: "fit-content" }}
                                  >
                                    <input
                                      className="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      id="teacherCompliance"
                                      checked={permissions.teacherCompliance}
                                      onChange={(e) =>
                                        handlePermissionChange(
                                          "teacherCompliance",
                                          e.target.checked,
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="teacherCompliance"
                                    >
                                      Teacher Compliance
                                    </label>
                                  </div>
                                </OverlayTrigger>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <Unauthorized />
      )}
    </>
  );
};

export default ManageRoles;
